import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TextValidators } from '../../shared/validators/text.validator';
import { CurrentStorageService } from 'src/app/core/services/current-storage.service';
import { ICommandResult } from 'src/app/app-store/entities/common';
import { IProviderIdentity, IRegistrationChallengeResult, IRegistrationStatus } from 'src/app/app-store/entities/registration';
import { RegistrationService } from '../registration/registration.service';
import { ProviderAttestationService } from '../ProviderAttestation/provider-attestation.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { environment } from 'src/environments/environment';

interface AdditionalTin {
  tin: string;
  name: string;
  status: 'pending' | 'registered';
  providerAttestationVendorId?: string;
  regCode?: string;
}

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})

export class RegistrationComponent implements OnInit {
  formGroup: FormGroup;
  returnUrl!: string;
  errorMessage!:string;
  error:boolean = false;
  token: string;
  registrationCode: string;
  verificationTin: string;
  verificationNpi: string;
  verificationAttempt: number = 1;
  verifiedProviderId: number = 0;
  step:string = 'verify';
  //step:string = 'select';
  hideRoleBack:boolean = false;
  hideSelectBack:boolean = false;
  registerSameDetails:boolean = false;
  userRole:string = '';
  copyright: string = environment.copyright;
  selection: SelectionType;
  columnMode = ColumnMode;
  verifiedVendorName: string;
  isOproFlow: boolean = false;
  oproTin: string = '';
  oproNpi: string = '';
  oproRole: string = '';
  additionalTinsList: AdditionalTin[] = [];
  currentAttestationPeriod: string = '';

  providerHistoryColumns = [];
  providerHistoryData: IProviderIdentity[] = [];
  @ViewChild(DatatableComponent) providerHistoryTable!: DatatableComponent;

  selected: any[] = [];
  selectColumns = [];
  providerSelectData: IProviderIdentity[] = [];
  providerSelectTempData: IProviderIdentity[] = [];
  @ViewChild(DatatableComponent) selecttable!: DatatableComponent;

  confirmColumns = [];
  providerConfirmData: IProviderIdentity[] = [];
  @ViewChild(DatatableComponent) confirmtable!: DatatableComponent;
  @ViewChild('oproModal') oproModal!: ElementRef;
  
  keyHandlers: { [key: string]: () => void };

  constructor(
    private fb:FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private currentStorageService: CurrentStorageService,
    private registrationService: RegistrationService,
    private providerAttestationService: ProviderAttestationService,
    public oidcSecurityService: OidcSecurityService
  ) {
    this.selection = SelectionType.checkbox;
    this.keyHandlers = {
      'Enter': () => this.verify(),
    };
    
    // Initialize form group in constructor to prevent undefined errors
    this.formGroup = this.fb.group({
      txtTIN: ['', [Validators.required,  Validators.maxLength(50), TextValidators.notEmpty],],
      txtNPI: ['',[Validators.required,  Validators.maxLength(50),TextValidators.notEmpty],],
    });
  }

  ngOnInit(): void {
    //debugger;
    this.registrationCode = this.route.snapshot.params['registrationCode'];
    if (this.registrationCode == undefined && this.registrationCode == "") {
      console.log('registrationCode missing');
      this.router.navigate(['/forbidden']);
    }

    // Check for OPRO flow
    this.checkOproFlow();
    
    this.currentStorageService.TIN = '';
    this.currentStorageService.SelectedProviderId = 0
    this.currentStorageService.NPI = '';

    // For debugging - expose component instance to window
    (window as any).regComponent = this;
  }

  private updateFormForOproFlow(tin: string, npi: string): void {
    // Recreate the form with disabled controls for OPRO flow
    this.formGroup = this.fb.group({
      txtTIN: [{value: this.maskTin(tin), disabled: true}, [Validators.required, Validators.maxLength(50), TextValidators.notEmpty]],
      txtNPI: [{value: npi, disabled: true}, [Validators.required, Validators.maxLength(50), TextValidators.notEmpty]],
    });
  }

  verify(): void {   
    this.error = false;
    this.errorMessage = '';
    
    // For OPRO flow, use the original unmasked values
    if (this.isOproFlow) {
      this.verificationTin = this.oproTin;
      this.verificationNpi = this.oproNpi;
      console.log('OPRO flow - using unmasked values for verification');
    } else {
      // For normal flow, use form values
      this.verificationTin = this.formGroup.get('txtTIN')?.value;
      this.verificationNpi = this.formGroup.get('txtNPI')?.value;
    }

    if (this.verificationTin != undefined && this.verificationTin != "" && this.verificationNpi != undefined && this.verificationNpi != "") {
      this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
        this.token = accessToken;
        this.registrationService.verifyRegistration(this.verificationTin, this.verificationNpi, this.registrationCode, this.token).subscribe({
          next: async (challengeResult: IRegistrationChallengeResult) => {
            //debugger;  
            console.log('OPRO flow - going to handleVerificationResult');
            this.handleVerificationResult(challengeResult);
          },
          error: (e) => {
            //debugger;   
            console.error('verify registration request failed with error - ' + JSON.stringify(e));
          }
        });
      });
    } else {
      this.error = true;
      this.errorMessage = 'Please enter valid TIN and NPI.';
    }
  }

  sameDetails():void{
    console.log('same details' + this.registerSameDetails);
    this.error = false;
    this.errorMessage = '';
    if (this.registerSameDetails == true) {
      console.log('saving same details.');
      if (this.verificationTin != undefined && this.verificationTin != "" && this.verificationNpi != undefined && this.verificationNpi != "") {
        this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
          this.token = accessToken;
          this.registrationService.registerPrevious(this.verificationTin, this.verificationNpi, this.registrationCode, this.token).subscribe({
            next: async (result: ICommandResult) => {
              //debugger;  
              if (result != undefined && result.success == true) {
                console.log(result.message);
                this.router.navigate(['/select']); 
              } 
              else { 
                this.error = true;
                if (result != undefined) {
                  this.errorMessage = result.message;
                }
              }
            },
            error: (e) => {
              //debugger;   
              console.error('register previous request failed with error - ' + JSON.stringify(e));
            }
          });
        });
      }
    } else {
      console.log('not saving same details, next step select.');
      this.step = 'role';
    }
  }

  roleSelect(navigation: string, bypassedUI: boolean):void {
    //debugger;
    console.log('roleSelect click: ' + navigation);
    console.log('roleSelect role: ' + this.userRole);
    if (navigation == 'next') {
      console.log('saving role.');
      if (this.verificationTin != undefined && this.verificationTin != "" && this.verificationNpi != undefined && this.verificationNpi != "") {
        this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
          this.token = accessToken;
          this.registrationService.assignRole(this.verificationTin, this.verificationNpi, this.registrationCode, this.userRole, this.token).subscribe({
            next: async (result: ICommandResult) => {
              //debugger;  
              if (result != undefined && result.success == true) {
                console.log(result.message);
                if (bypassedUI == true || this.userRole == 'provider') {
                  console.log('privder selected, saving and routing to select screen.');
                  this.router.navigate(['/select']); 
                } else {
                  if (this.verifiedProviderId > 0 && this.providerSelectData?.length == 1) {
                    this.currentStorageService.SelectedProviderId = this.verifiedProviderId;

                    // Check if this is OPRO flow with additional TINs
                    if (this.isOproFlow) 
                    {
                      console.log('OPRO flow detected with single provider in Role Select, checking for additional TINs... ' + this.currentAttestationPeriod );
                          // Now check for additional TINs
                      this.currentAttestationPeriod ;

                      this.initializeAdditionalTinsWithCallback(() => {
                      if (this.additionalTinsList && this.additionalTinsList.length > 0) {
                        console.log('Additional TINs found for single provider OPRO flow, showing OPRO modal');
                        this.showOproModal();
                      } else {
                        console.log('No additional TINs found for single provider OPRO flow, proceeding to select');
                        this.router.navigate(['/select']); 
                      }
                    });
                    } 
                    else 
                    {
                       // Normal flow (not OPRO)
                      this.router.navigate(['/select']); 
                    }
                  } else {
                    console.log('administrative, next step select.');
                    this.step = 'select';
                  }
                } 
              } 
              else { 
                this.error = true;
                if (result != undefined) {
                  this.errorMessage = result.message;
                }
              }
            },
            error: (e) => {
              //debugger;   
              console.error('vassign role request failed with error - ' + JSON.stringify(e));
            }
          });
        });
      }
    } 
    else {
      this.step = 'previous';
    }
  }

  providerSelect(navigation: string):void{
    console.log('providerSelect click: ' + navigation);
    if (navigation == 'next') {
      this.providerConfirmData = [...this.selected];
      this.step = 'confirm';
    } 
    else {
      this.step = 'role';
    }
  }
  keyPressValidation(event:any){
    let isvalid! : boolean;
    
      var str = String.fromCharCode(event.keyCode);
      let pattern = new RegExp("[0-9]");       
      if (pattern.test(str)) {
        isvalid=true;
      } 
      else 
      {
        event.preventDefault();
        isvalid=false;          
      }
    
    return isvalid;
  }
  providerConfirm(navigation: string):void {
    console.log('providerConfirm click: ' + navigation);
    console.log('providerSelect click: ' + navigation);
    if (navigation == 'next') {
      // Check if this is an OPRO flow
      if (this.isOproFlow) {
        console.log('OPRO flow detected in providerConfirm');
        this.continueProviderConfirmation(true);
        return;
      } else {
        console.log('Not an OPRO flow, proceeding with normal flow');
      }
      
      // Continue with normal flow
      this.continueProviderConfirmation(false);
    } 
    else {
      this.providerSelectData = [...this.providerSelectTempData];
      this.step = 'select';
    }
  }

  onSelect({ selected }: any) {
    console.log('Select Event', selected, this.selected);
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  updateSelectFilter(event: any) {
    //debugger;
    const val = event.target.value.toLowerCase();
    //console.log(val);
    const temp = this.providerSelectTempData.filter(function (d: any) {
      return d.npi.toLowerCase().indexOf(val) !== -1 || d.fullName.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.providerSelectData = temp;
  }

  checkOproFlow(): void {
    // Check if source parameter is 'opro' in URL
    const source = this.route.snapshot.queryParams['source'];
    
    if (source && source.toLowerCase() === 'opro') {
      console.log('OPRO flow detected, reading data from sessionStorage');
      
      // Read all OPRO data from sessionStorage
      try {
        const oProData = sessionStorage.getItem('oProRegistrationData');
        if (oProData) {
          const parsedOProData = JSON.parse(oProData);
          const tin = parsedOProData.tin;
          const npi = parsedOProData.npi;
          const role = parsedOProData.role;
          const additionalTins = parsedOProData.additionalTins;
          
          if (tin && npi) {
            this.isOproFlow = true;
            this.oproTin = tin;
            this.oproNpi = npi;
            this.oproRole = role || '';

            // Set the user role based on the role from sessionStorage
            if (role) {
              if (role.toLowerCase() === 'clinician' || role.toLowerCase() === 'provider') {
                this.userRole = 'provider';
              } else {
                this.userRole = 'administrative';
              }
              console.log('OPRO role set to:', this.userRole, 'based on sessionStorage role:', role);
            }

            // Set values in form controls with masked TIN and disable them
            this.updateFormForOproFlow(tin, npi);

            console.log('OPRO values populated from sessionStorage, waiting for user to click verify');
            
            // Check registration status to determine if we should bypass verification
            this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
              if (accessToken) {
                this.registrationService.getRegistrationStatus(this.registrationCode, accessToken).subscribe({
                  next: (registrationStatus: IRegistrationStatus) => {
                    console.log('Registration status:', registrationStatus);
                    
                    // If already registered and has additional TINs, skip verification and show OPRO modal directly
                    if (registrationStatus.registrationState === 'REGISTERED' && additionalTins) {
                      console.log('User already registered with additional TINs available, showing OPRO modal directly');
                      
                      // First get the latest attestation period before initializing additional TINs
                      this.providerAttestationService.getLatestAttestationPeriod().subscribe({
                        next: (attestationPeriod: string) => {
                          console.log('Latest attestation period retrieved:', attestationPeriod);
                          
                          // Set the current attestation period
                          this.currentAttestationPeriod = attestationPeriod || new Date().getFullYear().toString();
                          console.log('Set attestation period to:', this.currentAttestationPeriod);
                          
                          // Now initialize additional TINs with the correct attestation period
                          this.initializeAdditionalTinsWithCallback(() => {
                            if (this.additionalTinsList && this.additionalTinsList.length > 0) {
                              console.log('Showing OPRO modal directly for registered user with additional TINs');
                              this.showOproModal();
                            } else {
                              console.log('No additional TINs found despite data in sessionStorage');
                              this.router.navigate(['/select']); 
                              // Continue with normal flow if no additional TINs found
                            }
                          });
                        },
                        error: (error) => {
                          console.error('Error getting latest attestation period:', error);
                        }
                      });
                    } else {
                      console.log('User not registered or no additional TINs, continuing with verification flow');
                      // Continue with normal verification flow
                    }
                  },
                  error: (error) => {
                    console.error('Error checking registration status:', error);
                    // Continue with normal verification flow on error
                  }
                });
              } else {
                console.log('No access token available, continuing with normal verification flow');
                // Continue with normal verification flow
              }
            });
            
            // Initialize additional TINs for OPRO flow
            //this.initializeAdditionalTins();
            
            // Note: Keep OPRO data in sessionStorage for additional TINs processing
            // It will be cleared after the additional TINs modal is processed
          } else {
            console.log('OPRO flow detected but missing required TIN or NPI data');
          }
        } else {
          console.log('OPRO flow detected but no data found in sessionStorage');
        }
      } catch (error) {
        console.error('Error parsing OPRO data from sessionStorage:', error);
      }
    }
  }

  maskTin(tin: string): string {
    if (!tin || tin.length < 4) {
      return tin;
    }
    // Mask all digits except the last 4
    const masked = '*'.repeat(tin.length - 4) + tin.slice(-4);
    return masked;
  }

  handleVerificationResult(challengeResult: IRegistrationChallengeResult): void {
    if (challengeResult != undefined && challengeResult.successful == true) {
      this.currentStorageService.TIN = challengeResult.tin;
      // Store attestation period if available
      if (challengeResult.availableProviders && challengeResult.availableProviders.length > 0) {
        this.currentAttestationPeriod = challengeResult.availableProviders[0].attestationPeriod;
        console.log('Stored attestation period:', this.currentAttestationPeriod);
      }
      
      if (challengeResult.availableProviders != undefined && challengeResult.availableProviders?.length > 0) {
        this.verifiedProviderId = challengeResult.verifiedProviderId;
        this.providerSelectData = challengeResult.availableProviders?.filter(p => p.tin == challengeResult.tin);
        this.providerSelectTempData = challengeResult.availableProviders?.filter(p => p.tin == challengeResult.tin);
        this.selected.push(this.providerSelectData?.filter(p => p.providerId == challengeResult.verifiedProviderId)[0]);
      }
      if (challengeResult.availableProviders != undefined && challengeResult.providerHistory != undefined && challengeResult.providerHistory?.length > 1) {
        if (challengeResult.userRoleId == 1) {
          this.userRole = 'provider';
          this.roleSelect('next', true);
        } else {
          let currentPeriod = challengeResult.availableProviders[0].attestationPeriod;
          let currentProviders = challengeResult.providerHistory.filter(p => p.attestationPeriod == currentPeriod);
          if (currentProviders.some(p => p.providerId != challengeResult.verifiedProviderId)) {
            if (this.verifiedProviderId > 0 && this.providerSelectData?.length == 1) {
              console.log('OPRO: registered for other providers, single npi, checking for additional TINs before completion.');
              
              // Check if this is OPRO flow with additional TINs
              if (this.isOproFlow) {
                console.log('OPRO flow detected with single provider, checking for additional TINs...');
                // Now check for additional TINs
                    this.currentAttestationPeriod = currentPeriod;

                    this.initializeAdditionalTinsWithCallback(() => {
                      if (this.additionalTinsList && this.additionalTinsList.length > 0) {
                        console.log('Additional TINs found for single provider OPRO flow, showing OPRO modal');
                        this.showOproModal();
                      } else {
                        console.log('No additional TINs found for single provider OPRO flow, proceeding to select');
                        this.router.navigate(['/select']); 
                      }
                    });

              } else {
                // Normal flow (not OPRO)
                this.router.navigate(['/select']); 
              }
            } else {
              console.log('OPRO: registered for other providers, multi npi, next step select.');
              this.hideSelectBack = true;
              this.step = 'select';
              this.verifiedVendorName = this.providerSelectData[0].vendorName == "" ? "Organization" : this.providerSelectData[0].vendorName;
            }
          } else {
            let previousProviders = challengeResult.providerHistory.filter(p => p.attestationPeriod != currentPeriod);
            let attestionPeriods = [...new Set(previousProviders.map(p => p.attestationPeriod)) ];
            let nextPeriod = attestionPeriods.sort().reverse()[0];
            this.providerHistoryData = challengeResult.providerHistory.filter(p => p.attestationPeriod == nextPeriod);
            this.verifiedVendorName = this.providerHistoryData[0].vendorName == "" ? "Organization" : this.providerHistoryData[0].vendorName;
            //this.step = 'previous';
            //Skip "previous" step for OPRO flow
            if (this.isOproFlow) {
              console.log('OPRO flow: skipping previous step, going to role selection');
              this.step = 'role';
            } else {
              this.step = 'previous';
            }
          }
        }
      } else {
        console.log('OPRO: no provider history, next step role.');
        this.hideRoleBack = true;
        this.step = 'role';
      }
    } else {
      this.error = true;
      this.errorMessage = 'The tax identification number (TIN) and national provider identifier (NPI) do not match this attestation request.';
      if (this.verificationAttempt >= 3) {
        console.log('OPRO: 3rd attempt failed');
        this.router.navigate(['/forbidden/3']); 
      }
      this.verificationAttempt++;
    }
  }

  private continueProviderConfirmation(isOpro: boolean): void {
    // Original providerConfirm('next') logic
    if(!isOpro)
    {
        if (this.verificationTin != undefined && this.verificationTin != "" && this.verificationNpi != undefined && this.verificationNpi != "") {
          this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
            this.token = accessToken;
            let selectedProviders: IProviderIdentity[] = [...this.selected.map(p => { return <IProviderIdentity> { providerId: p.providerId, tin: p.tin, npi: p.npi } })];
            this.registrationService.saveSelectedProviders(this.verificationTin, this.verificationNpi, this.registrationCode, selectedProviders, this.token).subscribe({
              next: async (result: ICommandResult) => {
                console.log(result.message);
                if (result != undefined && result.success == true) {
                    this.router.navigate(['/select']); 
                } 
                else { 
                  this.error = true;
                  if (result != undefined) {
                    this.errorMessage = result.message;
                  }
                }
              },
              error: (e) => {
                console.error('save selected providers request failed with error - ' + JSON.stringify(e));
              }
            });
          });
        }
  }
  else{
    if (this.verificationTin != undefined && this.verificationTin != "" && this.verificationNpi != undefined && this.verificationNpi != "") {
          console.log(' Save Selected Provider in showOproModal ');
        this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
        this.token = accessToken;
        let selectedProviders: IProviderIdentity[] = [...this.selected.map(p => { return <IProviderIdentity> { providerId: p.providerId, tin: p.tin, npi: p.npi } })];
        const matchingTin = this.additionalTinsList?.find(tin => tin.tin === this.verificationTin);
        const regCode = matchingTin?.regCode || this.registrationCode;
        const npi = matchingTin?.regCode != null && matchingTin?.regCode != undefined  ? "opro" : this.verificationNpi;
        console.log('Debug Info:');
        console.log('this.verificationTin:', this.verificationTin);
        console.log('additionalTinsList:', this.additionalTinsList);
        console.log('matchingTin:', matchingTin);
        console.log('test npi:'+  npi );
        console.log('test regCode:'+  matchingTin?.regCode );

        this.registrationService.saveSelectedProviders(this.verificationTin, npi, regCode, selectedProviders, this.token).subscribe({
          next: async (result: ICommandResult) => {
            console.log(result.message);
            if (result != undefined && result.success == true) {
              // After provider confirmation is complete, initialize additional TINs
              this.initializeAdditionalTinsWithCallback(() => {
                console.log('Additional TINs list length:', this.additionalTinsList?.length);
                console.log('Additional TINs list:', this.additionalTinsList);
                
                // Show modal only if there are additional TINs
                if (this.additionalTinsList && this.additionalTinsList.length > 0) {
                  console.log('Showing OPRO modal with additional TINs');
                  this.showOproModal();
                } else {
                  console.log('OPRO flow but no additional TINs found, proceeding with normal flow');
                  // Clear OPRO data since no additional processing needed
                  sessionStorage.removeItem('oProRegistrationData');
                  // Continue with normal flow
                  this.router.navigate(['/select']); 
                }
              });
            } 
            else { 
              this.error = true;
              if (result != undefined) {
                this.errorMessage = result.message;
              }
            }
          },
          error: (e) => {
            console.error('save selected providers request failed with error - ' + JSON.stringify(e));
          }
        });
        
      });
        
    }
  }
  }

  initializeAdditionalTins(): void {
    console.log('initializeAdditionalTins called');
    // Check for additional TINs from OPRO data in sessionStorage
    const oProData = sessionStorage.getItem('oProRegistrationData');
    console.log('OPRO data from sessionStorage:', oProData);
    
    if (oProData) {
      try {
        const parsedOProData = JSON.parse(oProData);
        console.log('Parsed OPRO data:', parsedOProData);
        const additionalTins = parsedOProData.additionalTins;
        console.log('Additional TINs from OPRO data:', additionalTins);
        
        if (additionalTins) {
          // Check if additionalTins is a string (comma-separated TINs)
          if (typeof additionalTins === 'string' && additionalTins.length > 0) {
            console.log('Additional TINs is a string, fetching from Registration Controller');
            
            // Fetch organization data from Registration Controller
            this.fetchNotRegisteredAdditionalTins(additionalTins);
            return; // Exit early as we'll handle the rest in the callback
          }
          // Check if additionalTins is already an array
          else if (Array.isArray(additionalTins) && additionalTins.length > 0) {
            console.log('Additional TINs is an array, converting to comma-separated string');
            const tinsString = additionalTins.map(tin => tin.tin || tin.id || tin).join(',');
            this.fetchNotRegisteredAdditionalTins(tinsString);
            return;
          }
        } else {
          console.log('No additional TINs found in OPRO data');
          this.additionalTinsList = [];
        }
      } catch (error) {
        console.error('Error parsing OPRO data for additional TINs:', error);
        this.additionalTinsList = [];
      }
    } else {
      console.log('No OPRO data found in sessionStorage');
      this.additionalTinsList = [];
    }
    
    console.log('Final additionalTinsList:', this.additionalTinsList);
  }

  initializeAdditionalTinsWithCallback(callback: () => void): void {
    console.log('initializeAdditionalTinsWithCallback called');
    // Check for additional TINs from OPRO data in sessionStorage
    const oProData = sessionStorage.getItem('oProRegistrationData');
    console.log('OPRO data from sessionStorage:', oProData);
    
    if (oProData) {
      try {
        const parsedOProData = JSON.parse(oProData);
        console.log('Parsed OPRO data:', parsedOProData);
        const additionalTins = parsedOProData.additionalTins;
        console.log('Additional TINs from OPRO data:', additionalTins);
        
        if (additionalTins) {
          // Check if additionalTins is a string (comma-separated TINs)
          if (typeof additionalTins === 'string' && additionalTins.length > 0) {
            console.log('Additional TINs is a string, fetching from Registration Controller');
            
            // Fetch organization data from Registration Controller with callback
            this.fetchNotRegisteredAdditionalTinsWithCallback(additionalTins, callback);
            return; // Exit early as we'll handle the rest in the callback
          }
          // Check if additionalTins is already an array
          else if (Array.isArray(additionalTins) && additionalTins.length > 0) {
            console.log('Additional TINs is an array, converting to comma-separated string');
            const tinsString = additionalTins.map(tin => tin.tin || tin.id || tin).join(',');
            this.fetchNotRegisteredAdditionalTinsWithCallback(tinsString, callback);
            return;
          }
        } else {
          console.log('No additional TINs found in OPRO data');
          this.additionalTinsList = [];
        }
      } catch (error) {
        console.error('Error parsing OPRO data for additional TINs:', error);
        this.additionalTinsList = [];
      }
    } else {
      console.log('No OPRO data found in sessionStorage');
      this.additionalTinsList = [];
    }
    
    console.log('Final additionalTinsList:', this.additionalTinsList);
    // Call the callback since we're done (no async operations)
    callback();
  }

  showOproModal(): void {
    console.log('showOproModal called');
     
  
    // Initialize additional TINs if not already done
    if (!this.additionalTinsList || this.additionalTinsList.length === 0) {
      console.log('Initializing additional TINs in showOproModal');
      this.initializeAdditionalTins();
    }
    
    console.log('About to show modal with TINs:', this.additionalTinsList);
    
    // Show the modal using native DOM manipulation
    setTimeout(() => {
      const modalElement = document.getElementById('oproAdditionalTinsModal');
      console.log('Modal element found:', modalElement);
      if (modalElement) {
        // Add backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'modal-backdrop-opro';
        document.body.appendChild(backdrop);
        console.log('Backdrop added');
        
        // Show modal
        modalElement.style.display = 'block';
        modalElement.classList.add('show');
        modalElement.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        console.log('Modal should now be visible');
        
        // Focus on modal for accessibility
        modalElement.focus();
      } else {
        console.error('Modal element not found in DOM');
      }
    }, 10);
  }

  closeOproModal(): void {
    const modalElement = document.getElementById('oproAdditionalTinsModal');
    if (modalElement) {
      // Hide modal
      modalElement.classList.remove('show');
      modalElement.setAttribute('aria-hidden', 'true');
      
      // Remove backdrop
      const backdrop = document.getElementById('modal-backdrop-opro');
      if (backdrop) {
        backdrop.remove();
      }
      document.body.classList.remove('modal-open');
      
      // Hide modal with fade effect
      setTimeout(() => {
        modalElement.style.display = 'none';
      }, 150); // Bootstrap fade transition duration
    }
    //this.router.navigate(['/select']); 
  }

  cancelOproModal(): void {
    console.log('Cancel button clicked in OPRO modal');
    
    // Close the modal first
    this.closeOproModal();
    
   
    // Navigate to select screen
    this.router.navigate(['/select']);
  }

  registerAdditionalTin(tin: AdditionalTin): void {

    console.log(`Starting registration for additional TIN: ${tin.tin} - ${tin.name}`);
    
    const index = this.additionalTinsList.findIndex(t => t.tin === tin.tin);
    if (index !== -1) {
      this.additionalTinsList[index].status = 'registered';
      console.log(`Marked TIN as registered: ${tin.tin} - ${tin.name}`);
      
      // In OPRO flow for administrative role, navigate to provider selection with the selected TIN
      if (this.isOproFlow && this.userRole === 'administrative') {
        console.log(`OPRO Administrative flow: Going to provider selection for TIN ${tin.tin}`);
        
        // Set the selected TIN in storage
        this.currentStorageService.TIN = tin.tin;
        this.verificationTin = tin.tin;
        
        // Ensure NPI is set from OPRO data
        this.verificationNpi = this.oproNpi;
        this.currentStorageService.NPI = this.verificationNpi;
        
        // Save registered TINs to sessionStorage for persistence
        const registeredTins = this.additionalTinsList.filter(t => t.status === 'registered');
        sessionStorage.setItem('registeredAdditionalTins', JSON.stringify(registeredTins));
        
        // Clear OPRO data from sessionStorage now that we've processed the selection
        //sessionStorage.removeItem('oProRegistrationData');
        
        // Close the modal
        this.closeOproModal();
        
        // Reset any errors
        this.error = false;
        this.errorMessage = '';
        
        // First assign the administrative role for the new TIN, then fetch providers
        this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
          this.token = accessToken;
          
          console.log(`Assigning administrative role for TIN ${tin.tin}`);
          this.registrationService.assignRole(tin.tin, this.verificationNpi, this.registrationCode, this.userRole, this.token).subscribe({
            next: async (result: ICommandResult) => {
              if (result && result.success) {
                console.log(`Role assigned successfully for TIN ${tin.tin}:`, result.message);
                
                // Now fetch providers for the selected TIN
                const attestationPeriod = this.currentAttestationPeriod;
                console.log(`Fetching providers for TIN ${tin.tin} with attestation period: ${attestationPeriod}`);
                
                this.registrationService.getProvidersByTins([tin.tin], attestationPeriod, this.token).subscribe({
                  next: (providers: any[]) => {
                    console.log(`Fetched ${providers.length} providers for TIN ${tin.tin}:`, providers);
                    
                    if (providers && providers.length > 0) {
                      // Filter providers for the specific TIN and format provider names
                      const filteredProviders = providers.filter(p => p.tin === tin.tin).map(provider => {
                        // Format provider name as lastName,FirstName if not already formatted
                        if (provider.lastName && provider.firstName) {
                          provider.fullName = `${provider.lastName},${provider.firstName}`;
                        } else if (provider.fullName && !provider.fullName.includes(',')) {
                          // If fullName exists but no comma, try to parse and reformat
                          const nameParts = provider.fullName.trim().split(/\s+/);
                          if (nameParts.length >= 2) {
                            const firstName = nameParts[0];
                            const lastName = nameParts.slice(1).join(' ');
                            provider.fullName = `${lastName},${firstName}`;
                          }
                        } else if (!provider.fullName) {
                          // Fallback if no name information available
                          provider.fullName = `Provider ${provider.npi || provider.providerId || ''}`;
                        }
                        
                        return provider;
                      });
                      
                      console.log(`Filtered and formatted ${filteredProviders.length} providers for TIN ${tin.tin}:`, filteredProviders);
                      
                      // Update provider data for selection
                      this.providerSelectData = filteredProviders;
                      this.providerSelectTempData = filteredProviders;
                      
                      // Clear previous selections - let user choose
                      this.selected = [];
                      
                      // Set vendor name for display
                      this.verifiedVendorName = filteredProviders[0]?.vendorName === "" ? "Organization" : filteredProviders[0]?.vendorName;
                      
                      // Set navigation flags for OPRO flow
                      this.hideSelectBack = true; // Hide back button since we came from OPRO modal
                      this.hideRoleBack = true; // Hide role back as well
                      
                      // Navigate to provider selection step where user can select providers and click continue
                      console.log(`Navigating to provider select step for TIN ${tin.tin}`);
                      this.step = 'select';
                      
                    } else {
                      console.error(`No providers found for TIN ${tin.tin}`);
                      this.error = true;
                      this.errorMessage = `No providers found for the selected TIN ${tin.tin}.`;
                    }
                  },
                  error: (e) => {
                    console.error(`Fetch providers request failed for TIN ${tin.tin}:`, e);
                    this.error = true;
                    this.errorMessage = `Failed to fetch providers for the selected TIN ${tin.tin}.`;
                  }
                });
                
              } else { 
                this.error = true;
                if (result) {
                  this.errorMessage = result.message;
                } else {
                  this.errorMessage = 'Failed to assign role for the selected TIN.';
                }
              }
            },
            error: (e) => {
              console.error('Assign role request failed with error:', e);
              this.error = true;
              this.errorMessage = 'Failed to assign role for the selected TIN.';
            }
          });
        });
        
        
      } else {
        // For non-administrative roles or non-OPRO flow, just mark as registered
        console.log(`Non-administrative flow: TIN ${tin.tin} marked as registered`);
      }
    }
  }

  removeAdditionalTin(tin: AdditionalTin): void {
    // Show confirmation dialog
    //const confirmMessage = `Are you sure you want to permanently remove "${tin.name}" (TIN: ${tin.tin}) from your profile? This action cannot be undone.`;
    
    //if (confirm(confirmMessage)) {
      // User confirmed - call API to add vendor exclusion and then remove from UI
      //console.log('User confirmed removal, calling API and removing from UI');
      
      // Get the attestation period
      let attestationPeriod = this.currentAttestationPeriod;
       

      //test
      // Call API to add vendor exclusion
      if (tin.providerAttestationVendorId) {
        this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
          this.registrationService.addUserVendorExclusion(
            tin.tin, 
            attestationPeriod, 
            tin.providerAttestationVendorId!, 
            accessToken
          ).subscribe({
            next: (result) => {
              console.log('AddUserVendorExclusion API call successful:', result);
              // API call successful, now remove from UI
              this.removeFromUI(tin);
            },
            error: (error) => {
              console.error('AddUserVendorExclusion API call failed:', error);
              // Even if API call fails, still remove from UI as per existing logic
              this.removeFromUI(tin);
            }
          });
        });
      } else {
        console.warn('No providerAttestationVendorId found, skipping API call but removing from UI');
        // No vendor ID, just remove from UI
        this.removeFromUI(tin);
      }
    //} else {
     // console.log(`User cancelled removal of TIN: ${tin.tin} - ${tin.name}`);
    //}
  }

  private removeFromUI(tin: AdditionalTin): void {
    // Remove from array completely (existing logic)
    const index = this.additionalTinsList.findIndex(t => t.tin === tin.tin);
    if (index !== -1) {
      this.additionalTinsList.splice(index, 1);
      console.log(`Permanently removed TIN from UI: ${tin.tin} - ${tin.name}`);
      
      // Check if this was the last TIN in the list
      if (this.additionalTinsList.length === 0) {
        console.log('Last additional TIN removed, closing modal and navigating to /select');
        // Close the modal
        this.closeOproModal();
        // Navigate to select screen
        this.router.navigate(['/select']);
      }
    }
  }

  saveAdditionalTins(): void {
    // Get all registered TINs
    const registeredTins = this.additionalTinsList.filter(tin => tin.status === 'registered');
    console.log('Saving registered additional TINs:', registeredTins);
    
    // Save registered TINs to sessionStorage for persistence
    sessionStorage.setItem('registeredAdditionalTins', JSON.stringify(registeredTins));
    
    // Clear OPRO data from sessionStorage now that we've processed it
    //sessionStorage.removeItem('oProRegistrationData');
    
    // Here you would typically call a service to save the additional TINs
    // For now, we'll just close the modal and continue with the normal flow
    this.closeOproModal();
    
    // Continue with the original provider confirmation logic
    this.router.navigate(['/select']); 
  }

  onModalBackdropClick(event: Event): void {
    // Close modal when clicking on backdrop (outside the modal dialog)
    //this.closeOproModal();
  }
  
  private fetchNotRegisteredAdditionalTins(additionalTinsString: string): void {
    console.log('Fetching not registered additional TINs:', additionalTinsString);
    
    // Get the attestation period
    let attestationPeriod = this.currentAttestationPeriod;
    //console.log('Using default attestation period:', attestationPeriod);

    
    this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
      this.registrationService.getNotRegisteredAdditionalTins(additionalTinsString, attestationPeriod, accessToken).subscribe({
        next: (notRegisteredTins: any[]) => {
          console.log('Fetched not registered additional TINs data:', notRegisteredTins);
          
          // Log the first item to see the actual structure
          if (notRegisteredTins.length > 0) {
            console.log('First TIN object structure:', notRegisteredTins[0]);
            console.log('Available properties:', Object.keys(notRegisteredTins[0]));
          }
          
          // The API response contains the actual data to be displayed in the modal
          this.additionalTinsList = notRegisteredTins.map(tin => ({
            tin: tin.tin,
            name: tin.groupVendorName || `Organization ${tin.tin}`,
            status: 'pending' as 'pending' | 'registered',
            providerAttestationVendorId: tin.providerAttestationVendorId,
            regCode: tin.regCode
          }));
          
          console.log('Additional TINs loaded from Registration Controller:', this.additionalTinsList);
        },
        error: (error) => {
          console.error('Error fetching not registered additional TINs:', error);
          
          // Fallback to default naming if API call fails
          const originalTins = additionalTinsString.split(',').map(tin => tin.trim()).filter(tin => tin.length > 0);
          this.additionalTinsList = originalTins.map(tin => ({
            tin: tin,
            name: `Organization ${tin}`,
            status: 'pending' as 'pending' | 'registered',
            providerAttestationVendorId: undefined,
            regCode: undefined
          }));
          
          console.log('Additional TINs loaded with default names (API error):', this.additionalTinsList);
        }
      });
    });
  }

  private fetchNotRegisteredAdditionalTinsWithCallback(additionalTinsString: string, callback: () => void): void {
    console.log('Fetching not registered additional TINs with callback:', additionalTinsString);
    
    // Get the attestation period
    let attestationPeriod = this.currentAttestationPeriod;
    //console.log('Using default attestation period:', attestationPeriod);

    
    this.oidcSecurityService.getAccessToken().subscribe(accessToken => {
      this.registrationService.getNotRegisteredAdditionalTins(additionalTinsString, attestationPeriod, accessToken).subscribe({
        next: (notRegisteredTins: any[]) => {
          console.log('Fetched not registered additional TINs data:', notRegisteredTins);
          
          // Log the first item to see the actual structure
          if (notRegisteredTins.length > 0) {
            console.log('First TIN object structure:', notRegisteredTins[0]);
            console.log('Available properties:', Object.keys(notRegisteredTins[0]));
          }
          
          // The API response contains the actual data to be displayed in the modal
          this.additionalTinsList = notRegisteredTins.map(tin => ({
            tin: tin.tin,
            name: tin.groupVendorName || `Organization ${tin.tin}`,
            status: 'pending' as 'pending' | 'registered',
            providerAttestationVendorId: tin.providerAttestationVendorId,
            regCode: tin.regCode
          }));
          
          console.log('Additional TINs loaded from Registration Controller:', this.additionalTinsList);
          
          // Call the callback now that data is loaded
          callback();
        },
        error: (error) => {
          console.error('Error fetching not registered additional TINs:', error);
          
          // Fallback to default naming if API call fails
          const originalTins = additionalTinsString.split(',').map(tin => tin.trim()).filter(tin => tin.length > 0);
          this.additionalTinsList = originalTins.map(tin => ({
            tin: tin,
            name: `Organization ${tin}`,
            status: 'pending' as 'pending' | 'registered',
            providerAttestationVendorId: undefined,
            regCode: undefined
          }));
          
          console.log('Additional TINs loaded with default names (API error):', this.additionalTinsList);
          
          // Call the callback even on error
          callback();
        }
      });
    });
  }

}
